/* Mastichová kalkulačka v2 — konfigurace otázek, pravidel a dávkování.
 * Tento soubor je jediné místo, kde žije doporučovací logika. Změny schvaluje odborník.
 * Stejný pro všechny obchody; texty UI se překládají přes theme locales (klíče `t`),
 * při chybějícím překladu se použije český text `cs`.
 */
(function (root) {
  "use strict";

  var MLK_CONFIG = {
    verze: "2.0.0",

    /* Cenová tolerance, do které se preferuje menší počet balení (0.05 = +5 %). */
    tolerancePoctuBaleni: 0.05,

    /* ---------- Kroky dotazníku ---------- */
    kroky: [
      {
        id: "goal", typ: "single", povinny: true,
        t: "goal", cs: { titulek: "Co chcete s mastichou řešit především?", podtitulek: "Vyberte hlavní důvod. Když si nejste jistí, zvolte poslední možnost." },
        volby: [
          { v: "prevence", ic: "🌿", cs: { b: "Prevence / podpora trávení", d: "Chci mastichu preventivně, bez výrazných potíží" } },
          { v: "dyspepsie", ic: "😖", cs: { b: "Trávicí potíže (dyspepsie)", d: "Nadýmání, tlak v žaludku, plný žaludek" } },
          { v: "helicobacter", ic: "🦠", cs: { b: "Helicobacter pylori", d: "Podezření nebo potvrzená infekce žaludku" } },
          { v: "vred_gastritida", ic: "🔥", cs: { b: "Gastritida / žaludeční vřed", d: "Pálení a bolest žaludku" } },
          { v: "reflux", ic: "↩️", cs: { b: "Reflux / pálení žáhy", d: "Pálení za hrudní kostí, kyselá pachuť" } },
          { v: "mikroflora", ic: "🌀", cs: { b: "Střevní mikroflóra", d: "Po antibiotikách, nepravidelná stolice" } },
          { v: "cholesterol", ic: "❤️", cs: { b: "Cholesterol / srdce a cévy", d: "Podpora normální hladiny cholesterolu" } },
          { v: "imunita", ic: "🛡️", cs: { b: "Imunita a kosti", d: "Podpora hlavně v zimě (s vitaminem D3)" } },
          { v: "ustni", ic: "🦷", cs: { b: "Ústní zdraví / dech", d: "Plak, zápach z úst, péče o dásně" } },
          /* Nový cíl „posílení čelistí" — aktivuje se nastavením aktivni:true po schválení dávky odborníkem. */
          { v: "celisti", ic: "💪", aktivni: false, cs: { b: "Posílení čelistí", d: "Trénink žvýkacích svalů žvýkáním surové mastichy" } },
          { v: "nevim", ic: "❓", cs: { b: "Nejsem si jistý/á", d: "Poraďte mi podle příznaků" } }
        ]
      },
      {
        id: "symptoms", typ: "multi", povinny: false,
        zobrazKdyz: [{ p: "goal", in: ["nevim"] }],
        t: "symptoms", cs: { titulek: "Které příznaky vás trápí?", podtitulek: "Vyberte vše, co sedí — podle toho zvolíme zaměření." },
        volby: [
          { v: "reflux", ic: "🔥", cs: { b: "Pálení žáhy, kyselá pachuť" } },
          { v: "dyspepsie", ic: "🎈", cs: { b: "Nadýmání, plný žaludek, tlak po jídle" } },
          { v: "vred_gastritida", ic: "😣", cs: { b: "Bolest žaludku, nevolnost" } },
          { v: "mikroflora", ic: "🌀", cs: { b: "Plynatost, nepravidelná stolice" } },
          { v: "ustni", ic: "😮‍💨", cs: { b: "Zápach z úst, plak" } },
          { v: "imunita", ic: "🤧", cs: { b: "Časté nachlazení, únava" } }
        ]
      },
      {
        id: "hpylori", typ: "single", povinny: true,
        zobrazKdyz: [{ p: "goal", in: ["prevence", "dyspepsie", "vred_gastritida", "reflux", "mikroflora", "nevim"] }],
        t: "hpylori", cs: { titulek: "Týká se vás Helicobacter pylori?", podtitulek: "Bakterie v žaludku, která bývá příčinou potíží i vředů." },
        volby: [
          { v: "potvrzeny", ic: "✅", cs: { b: "Ano, potvrzený", d: "Mám pozitivní test / od lékaře" } },
          { v: "podezreni", ic: "❓", cs: { b: "Mám podezření", d: "Příznaky tomu odpovídají, chci otestovat" } },
          { v: "ne", ic: "➖", cs: { b: "Ne / nevím", d: "Netýká se mě nebo nevím" } }
        ]
      },
      {
        id: "extra", typ: "multi", povinny: false,
        t: "extra", cs: { titulek: "Chcete podpořit i něco navíc?", podtitulek: "Volitelné — můžete vybrat víc možností, nebo žádnou." },
        volby: [
          { v: "mikroflora", ic: "🦠", cs: { b: "Střevní mikroflóra", d: "Prebiotika / probiotika" } },
          { v: "imunita", ic: "🛡️", cs: { b: "Imunita a kosti", d: "S vitaminem D3" } },
          { v: "cholesterol", ic: "❤️", cs: { b: "Cholesterol", d: "Mastichový olej" } },
          { v: "ustni", ic: "🦷", cs: { b: "Ústní zdraví", d: "Žvýkání / sáčky" } },
          { v: "ne", ic: "✓", cs: { b: "Ne, stačí hlavní cíl", d: "" } }
        ]
      },
      {
        id: "form", typ: "single", povinny: true,
        t: "form", cs: { titulek: "Jaká forma vám vyhovuje?", podtitulek: "Jak chcete mastichu užívat." },
        volby: [
          { v: "kapsle", ic: "💊", cs: { b: "Kapsle", d: "Spolknout a zapít — bez chuti" } },
          { v: "sacky", ic: "📦", cs: { b: "Sáčky s práškem", d: "Pohodlné, i mimo domov" } },
          { v: "prasek", ic: "🥄", cs: { b: "Volný prášek", d: "Do nápoje/jídla, nejlevnější" } },
          { v: "zvykani", ic: "🫧", cs: { b: "Žvýkání", d: "Surové slzy / žvýkací tablety" } },
          { v: "nezalezi", ic: "🤷", cs: { b: "Nezáleží", d: "Vyberte za mě to nejlepší" } }
        ]
      },
      {
        id: "intensity", typ: "single", povinny: true,
        t: "intensity", cs: { titulek: "Jak intenzivní kúru chcete?", podtitulek: "Podle toho zvolíme dávku, délku kúry i velikost balení." },
        volby: [
          { v: "lehka", ic: "🍃", cs: { b: "Lehká / preventivní", d: "Nižší dávka, vyzkoušení" } },
          { v: "standard", ic: "⏳", cs: { b: "Standardní kúra", d: "Plná dávka, ~60 dní" } },
          { v: "intenzivni", ic: "⚡", cs: { b: "Intenzivní / dlouhá", d: "Nejvyšší dávka, 80+ dní" } }
        ]
      },
      {
        id: "safety", typ: "multi", povinny: false,
        t: "safety", cs: { titulek: "Týká se vás něco z tohoto?", podtitulek: "Kvůli bezpečnosti. Pokud nic, zvolte poslední možnost." },
        volby: [
          { v: "redflag", ic: "⛔", cs: { b: "Krev ve stolici/zvracení, hubnutí, potíže s polykáním", d: "Vážnější příznaky" } },
          { v: "tehotenstvi", ic: "🤰", cs: { b: "Těhotenství / kojení" } },
          { v: "dite", ic: "🧒", cs: { b: "Pro dítě (do 3 let)" } },
          { v: "nizky_tlak", ic: "🩸", cs: { b: "Nízký krevní tlak" } },
          { v: "probiotika_atb", ic: "💊", cs: { b: "Užívám probiotika / antibiotika" } },
          { v: "zadne", ic: "✓", cs: { b: "Nic z toho" } }
        ]
      }
    ],

    /* ---------- Mapování příznaků na cíl (krok „nevím") ---------- */
    symptomyNaCil: { reflux: "reflux", dyspepsie: "dyspepsie", vred_gastritida: "vred_gastritida", mikroflora: "mikroflora", ustni: "ustni", imunita: "imunita" },
    vychoziCil: "prevence",

    /* ---------- Dávkovací tabulka (cíl/řada × intenzita) — SCHVALUJE ODBORNÍK ----------
     * mg       … denní dávka mastichy v mg (engine přepočte na jednotky přes složení řady)
     * jednotky … denní dávka přímo v jednotkách řady (kapsle/sáčky/gramy) — pro řady bez mg dávkování
     * kuraDni  … doporučená délka kúry; null = průběžné užívání (nezobrazuje se počet balení)
     */
    davkovani: {
      strong_pure: {
        lehka:      { mg: 700,  kuraDni: 49,  cs: "1–2 kapsle denně (350–700 mg), nalačno" },
        standard:   { mg: 1050, kuraDni: 60,  cs: "3 kapsle denně (1050 mg), nalačno" },
        intenzivni: { mg: 1400, kuraDni: 100, cs: "4 kapsle denně (1400 mg), nalačno" }
      },
      hp: {
        lehka:      { mg: 1400, kuraDni: 30, cs: "4 kapsle Strong&Pure denně (1400 mg), nalačno" },
        standard:   { mg: 1400, kuraDni: 60, cs: "4 kapsle Strong&Pure denně (1400 mg), nalačno" },
        intenzivni: { mg: 1400, kuraDni: 60, cs: "4 kapsle Strong&Pure denně (1400 mg), nalačno" }
      },
      comfort: {
        lehka:      { jednotky: 1, kuraDni: 28, cs: "1 sáček denně, nalačno" },
        standard:   { jednotky: 2, kuraDni: 60, cs: "1–2 sáčky denně, nalačno" },
        intenzivni: { jednotky: 2, kuraDni: 60, cs: "2 sáčky denně, nalačno" }
      },
      prebiotic: {
        lehka:      { jednotky: 2, kuraDni: 42, cs: "1–2 kapsle denně" },
        standard:   { jednotky: 4, kuraDni: 56, cs: "2 kapsle 2× denně" },
        intenzivni: { jednotky: 4, kuraDni: 56, cs: "2 kapsle 2× denně" }
      },
      vital:      { vse: { jednotky: 2, kuraDni: 30, cs: "2 kapsle denně (ráno + večer)" } },
      imunita:    { vse: { jednotky: 2, kuraDni: 80, cs: "2 kapsle denně" } },
      zvykani:    { vse: { jednotky: 2, kuraDni: null, cs: "žvýkat ~1–2 g denně (10–15 minut)" } },
      prasek: {
        lehka:      { jednotky: 1.5, kuraDni: 49, cs: "½ lžičky denně (0,8–1,5 g) do nápoje či jídla" },
        standard:   { jednotky: 3,   kuraDni: 25, cs: "1 lžička denně (2–3 g) do nápoje či jídla" },
        intenzivni: { jednotky: 3,   kuraDni: 25, cs: "1 lžička denně (2–3 g) do nápoje či jídla" }
      },
      olej:       { vse: { kuraDni: 56, cs: "dle návodu (do nápoje / přímo)" } },
      extra:      { vse: { kuraDni: 60, cs: "ráno 2 + večer 2 kapsle Strong&Pure, v poledne 2 kapsle Vital" } },
      /* celisti: { vse: { jednotky: ?, kuraDni: ?, cs: "?" } },  ← doplní odborník před aktivací cíle */
    },

    /* Výchozí dávkovací klíč řady — použije se u alternativ, fallbacků a vedlejších doporučení. */
    radaDavkovani: {
      strong_pure: "strong_pure", comfort: "comfort", prebiotic: "prebiotic", vital: "vital",
      vitamin_d3: "imunita", active_pack: "imunita", plus_pack: "imunita",
      slzy: "zvykani", tablety: "zvykani", prasek: "prasek", prasek_inulin: "prasek",
      olej: "olej", extra: "extra", hp_sada: "hp"
    },

    /* ---------- Pravidla výběru řady (vyhodnocují se shora, první shoda vyhrává) — SCHVALUJE ODBORNÍK ---------- */
    pravidla: [
      { id: "hp_cil",      kdyz: [{ p: "goal", in: ["helicobacter"] }],                                          rada: "hp_sada", alt: "strong_pure", dav: "hp" },
      { id: "hp_odpoved",  kdyz: [{ p: "hpylori", in: ["potvrzeny", "podezreni"] }],                             rada: "hp_sada", alt: "strong_pure", dav: "hp" },
      { id: "ustni",       kdyz: [{ p: "goal", in: ["ustni"] }],                                                 rada: "slzy", alt: "tablety", dav: "zvykani" },
      /* { id: "celisti",  kdyz: [{ p: "goal", in: ["celisti"] }],                                               rada: "slzy", alt: "tablety", dav: "celisti" },  ← aktivovat s cílem */
      { id: "zvykani",     kdyz: [{ p: "form", in: ["zvykani"] }],                                               rada: "slzy", alt: "tablety", dav: "zvykani" },
      { id: "chol_int",    kdyz: [{ p: "cilNeboExtra", v: "cholesterol" }, { p: "intensity", in: ["intenzivni"] }], rada: "extra", alt: "prasek_inulin", dav: "extra" },
      { id: "cholesterol", kdyz: [{ p: "cilNeboExtra", v: "cholesterol" }],                                      rada: "olej", alt: "prasek_inulin", dav: "olej" },
      { id: "imunita",     kdyz: [{ p: "cilNeboExtra", v: "imunita" }],
        radaDle: { lehka: "vitamin_d3", standard: "active_pack", intenzivni: "plus_pack" },
        altDle:  { lehka: "active_pack", standard: "vitamin_d3", intenzivni: "vitamin_d3" }, dav: "imunita" },
      { id: "mikro_forma", kdyz: [{ p: "cilNeboExtra", v: "mikroflora" }, { p: "form", in: ["sacky", "prasek"] }], rada: "comfort", alt: "prebiotic", dav: "comfort" },
      { id: "mikro_atb",   kdyz: [{ p: "cilNeboExtra", v: "mikroflora" }, { p: "safety", maNektery: ["probiotika_atb"] }], rada: "vital", alt: "prebiotic", dav: "vital" },
      { id: "mikroflora",  kdyz: [{ p: "cilNeboExtra", v: "mikroflora" }],                                       rada: "prebiotic", alt: "vital", dav: "prebiotic" },
      { id: "sacky",       kdyz: [{ p: "form", in: ["sacky"] }],                                                 rada: "comfort", alt: "strong_pure", dav: "comfort" },
      { id: "reflux",      kdyz: [{ p: "goal", in: ["reflux"] }],                                                rada: "comfort", alt: "strong_pure", dav: "comfort" },
      { id: "prasek",      kdyz: [{ p: "form", in: ["prasek"] }],                                                rada: "prasek", alt: "comfort", dav: "prasek" },
      { id: "vychozi",     kdyz: [],                                                                             rada: "strong_pure", alt: "comfort", dav: "strong_pure" }
    ],

    /* ---------- Doplňkové tipy: vedlejší cíl → řada (když ho nepokryje primární doporučení) ---------- */
    tipy: { imunita: "vitamin_d3", mikroflora: "prebiotic", cholesterol: "olej", ustni: "slzy" },

    /* ---------- Bezpečnostní pravidla (aditivní, nezávislá na výběru řady) — SCHVALUJE ODBORNÍK ---------- */
    bezpecnost: [
      { id: "redflag", kdyz: [{ p: "safety", maNektery: ["redflag"] }], lekar: true,
        cs: "Uvedl(a) jste varovný příznak (krev ve stolici/zvracení, výrazný úbytek váhy, potíže s polykáním nebo silná bolest). Nejdřív prosím navštivte lékaře — doplněk stravy není náhradou vyšetření." },
      { id: "tehotenstvi", kdyz: [{ p: "safety", maNektery: ["tehotenstvi", "dite"] }],
        cs: "Mastichové doplňky nejsou určeny pro děti do 3 let, těhotné a kojící ženy." },
      { id: "nizky_tlak", kdyz: [{ p: "safety", maNektery: ["nizky_tlak"] }],
        cs: "Masticha může snižovat krevní tlak — prvních 5 dní užívejte max. 2 kapsle/den a tlak kontrolujte." },
      { id: "atb", kdyz: [{ p: "safety", maNektery: ["probiotika_atb"] }],
        cs: "Mezi mastichou a probiotiky/antibiotiky dělejte odstup ≥ 4 h. Masticha Vital to řeší dvojkapslí COMBICAPS (lze užít spolu)." },
      { id: "ibd", kdyz: [{ p: "goal", in: ["ibd"] }], lekar: true,
        cs: "U zánětlivého střevního onemocnění (Crohn, kolitida) berte mastichu jen jako doplněk a postup vždy probírejte s lékařem." },
      { id: "vred", kdyz: [{ p: "goal", in: ["vred_gastritida"] }],
        cs: "U gastritidy nebo vředu doporučujeme postup probrat s lékařem (časté je pozadí H. pylori)." },
      { id: "hp_potvrzeny", kdyz: [{ p: "hpylori", in: ["potvrzeny"] }],
        cs: "Při potvrzené infekci H. pylori užívejte mastichu jako doplněk k léčbě předepsané lékařem." }
    ]
  };

  if (typeof module !== "undefined" && module.exports) module.exports = MLK_CONFIG;
  else root.MLK_CONFIG = MLK_CONFIG;
})(typeof window !== "undefined" ? window : globalThis);
